import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  getPagedContracts,
  addOwnContracts,
  getContractDetail,
  getContractsStandartRates,
  getOldContractsRates,
  getContractsToPartner,
  addReferralLinkDetailsForLanguage,
  getOwnContractReview,
} from "./thunk";

interface ContractsState {
  getPagedContractsData: any;
  getPagedContractsLoading: boolean;
  isListSuccess: boolean;
  addOwnContractsData: any;
  isAddOwnContractsSuccess: boolean;
  getOwnContractReviewData: any;
  isListOwnContractReviewSuccess: boolean;
  getContractDetailData: any;
  isContractDetailListSuccess: boolean;
  getContractsStandartRatesData: any;
  isListStandartRatesSuccess: boolean;
  getOldContractsRatesData: any;
  isListOldContractsRatesSuccess: boolean;
  getContractsToPartnerData: any;
  isListContractsToPartnerSuccess: boolean;
  addReferralLinkDetailsForLanguageData: any;
  isReferralLinkDetailsForLanguageSuccess: boolean;
  error: boolean;
}

export const initialState: ContractsState = {
  // getPagedContracts
  getPagedContractsData: [],
  getPagedContractsLoading: false,
  isListSuccess: false,
  // addOwnContracts
  addOwnContractsData: [],
  isAddOwnContractsSuccess: false,
  // getOwnContractReview
  getOwnContractReviewData: [],
  isListOwnContractReviewSuccess: false,
  // getPagedContracts
  getContractDetailData: {},
  isContractDetailListSuccess: false,
  // getContractsStandartRates
  getContractsStandartRatesData: [],
  isListStandartRatesSuccess: false,
  // getOldContractsRates
  getOldContractsRatesData: [],
  isListOldContractsRatesSuccess: false,
  // getContractsToPartner
  getContractsToPartnerData: [],
  isListContractsToPartnerSuccess: false,
  // addReferralLinkDetailsForLanguage
  addReferralLinkDetailsForLanguageData: [],
  isReferralLinkDetailsForLanguageSuccess: false,
  // Error Handling
  error: false,
};

const ContractsSlice = createSlice({
  name: "ContractsSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // getPagedContracts
    builder.addCase(getPagedContracts.pending, (state) => {
      state.getPagedContractsLoading = true;
      state.error = false;
    });
    builder.addCase(getPagedContracts.fulfilled, (state: any, action: any) => {
      state.getPagedContractsData = action.payload;
      state.getPagedContractsLoading = false;
      state.isListSuccess = true;
      state.error = false;
    });
    builder.addCase(getPagedContracts.rejected, (state: any, action: any) => {
      state.getPagedContractsLoading = false;
      state.error = action.payload || null;
    });
    // addOwnContracts
    builder.addCase(addOwnContracts.fulfilled, (state: any, action: any) => {
      state.addOwnContractsData = action.payload;
      state.isAddOwnContractsSuccess = true;
      state.error = false;
    });
    builder.addCase(addOwnContracts.rejected, (state: any, action: any) => {
      state.error = action.payload || null;
    });
    // getOwnContractReview
    builder.addCase(
      getOwnContractReview.fulfilled,
      (state: any, action: any) => {
        state.getOwnContractReviewData = action.payload;
        state.isListOwnContractReviewSuccess = true;
        state.error = false;
      }
    );
    builder.addCase(
      getOwnContractReview.rejected,
      (state: any, action: any) => {
        state.error = action.payload || null;
      }
    );
    // getContractDetail
    builder.addCase(getContractDetail.fulfilled, (state: any, action: any) => {
      state.getContractDetailData = action.payload;
      state.isContractDetailListSuccess = true;
      state.error = false;
    });
    builder.addCase(getContractDetail.rejected, (state: any, action: any) => {
      state.error = action.payload || null;
    });
    // getContractsStandartRates
    builder.addCase(
      getContractsStandartRates.fulfilled,
      (state: any, action: any) => {
        state.getContractsStandartRatesData = action.payload;
        state.isListStandartRatesSuccess = true;
        state.error = false;
      }
    );
    builder.addCase(
      getContractsStandartRates.rejected,
      (state: any, action: any) => {
        state.error = action.payload.error || null;
      }
    );
    // getOldContractsRates
    builder.addCase(
      getOldContractsRates.fulfilled,
      (state: any, action: any) => {
        state.getOldContractsRatesData = action.payload;
        state.isListOldContractsRatesSuccess = true;
        state.error = false;
      }
    );
    builder.addCase(
      getOldContractsRates.rejected,
      (state: any, action: any) => {
        state.error = action.payload.error || null;
      }
    );
    // getContractsToPartner
    builder.addCase(
      getContractsToPartner.fulfilled,
      (state: any, action: any) => {
        state.getContractsToPartnerData = action.payload;
        state.isListContractsToPartnerSuccess = true;
        state.error = false;
      }
    );
    builder.addCase(
      getContractsToPartner.rejected,
      (state: any, action: any) => {
        state.error = action.payload || null;
      }
    );
    // addReferralLinkDetailsForLanguage
    builder.addCase(
      addReferralLinkDetailsForLanguage.fulfilled,
      (state: any, action: any) => {
        state.addReferralLinkDetailsForLanguageData = action.payload;
        state.isReferralLinkDetailsForLanguageSuccess = true;
        state.error = false;
      }
    );
    builder.addCase(
      addReferralLinkDetailsForLanguage.rejected,
      (state: any, action: any) => {
        state.error = action.payload || null;
      }
    );
  },
});

export default ContractsSlice.reducer;
